import React from 'react'
import {
  MdOutlineDashboardCustomize,
  MdMotionPhotosPaused,
  MdOutlineSubject,
} from 'react-icons/md'
import { SiAnaconda } from 'react-icons/si'
import { IoIosLogOut } from 'react-icons/io'
import { MdPersonAdd } from 'react-icons/md'
import { RiQuestionAnswerLine } from 'react-icons/ri'
import { TbExchange } from 'react-icons/tb'

export const SidebarData = [
  {
    title: 'Dashboard',
    path: '/examdashboard',
    icon: <MdOutlineDashboardCustomize />,
    cName: 'examnavtext nav-text',
  },
  {
    title: 'Add Students',
    path: '/viewstudents',
    icon: <MdPersonAdd />,
    cName: 'examnavtext nav-text',
  },
  {
    title: 'Subject Mgmt',
    path: '/viewsubjects',
    icon: <MdOutlineSubject />,
    cName: 'examnavtext nav-text',
  },
  {
    title: 'Exam Mgmt',
    path: '/viewexams',
    icon: <SiAnaconda />,
    cName: 'examnavtext nav-text',
  },
  {
    title: 'Question Mgmt',
    path: '/viewquestion',
    icon: <RiQuestionAnswerLine />,
    cName: 'examnavtext nav-text',
  },
  {
    title: 'Exam Status',
    path: '/examstatus',
    icon: <MdMotionPhotosPaused />,
    cName: 'examnavtext nav-text',
  },
  {
    title: 'Switch Portal',
    path: '/portal',
    icon: <TbExchange />,
    cName: 'examnavtext nav-text',
  },

  {
    title: 'Logout',
    path: '',
    icon: <IoIosLogOut />,
    cName: 'examnavtext nav-text',
  },
]
